<template>
  <mouse-layout :can-move-to-list="false" :loading="loading">
    <md-content>
      <div class="container">
        <div
          class="operation-container button-group"
          v-if="0 < downloadRequests.length"
        >
          <gl-button
            dense
            primary
            icon-pre="add-box"
            class="button-group__button"
            @click="newRequest"
          >
            データを作成
          </gl-button>
          <gl-button
            dense
            primary
            icon-pre="refresh"
            class="button-group__button"
            @click="reload"
          >
            更新
          </gl-button>
          <gl-button
            dense
            primary
            icon-pre="delete"
            class="button-group__button"
            :disabled="selected === undefined"
            @click="deleteRequest"
          >
            削除
          </gl-button>
        </div>

        <div class="table-container">
          <md-table
            v-model="downloadRequests"
            md-card
            @md-selected="onSelect"
            v-if="0 < downloadRequests.length"
            class="table"
          >
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              class="md-primary"
              md-selectable="single"
            >
              <md-table-cell class="status">
                <div class="status-icon">
                  <div
                    gl-tooltip="ダウンロードできます"
                    gl-tooltip-direction="right"
                    v-if="item.status == 'Completed'"
                  >
                    <md-icon :class="item.status.toLowerCase()"
                      >cloud_download</md-icon
                    >
                  </div>
                  <div
                    gl-tooltip="作成中です"
                    gl-tooltip-direction="right"
                    v-else-if="item.status == 'Working'"
                  >
                    <md-icon :class="item.status.toLowerCase()">build</md-icon>
                  </div>
                  <div
                    gl-tooltip="対象となるデータがありませんでした"
                    gl-tooltip-direction="right"
                    v-else-if="item.status == 'NoResult'"
                  >
                    <md-icon :class="item.status.toLowerCase()"
                      >search_off</md-icon
                    >
                  </div>
                  <div
                    gl-tooltip="エラーが発生しました"
                    gl-tooltip-direction="right"
                    v-else
                  >
                    <md-icon :class="item.status.toLowerCase()">error</md-icon>
                  </div>
                </div>
              </md-table-cell>

              <md-table-cell md-label="作成日時" class="requested-at">
                {{ item.requestedAt }}
              </md-table-cell>
              <md-table-cell md-label="説明" class="description">{{
                item.description
              }}</md-table-cell>
              <md-table-cell md-label="サイズ(GB)" class="size">
                <!-- 0.01GB未満は0.01固定 -->
                {{
                  item.size === 0
                    ? 0
                    : item.size >= 1024 ** 2 * 10
                    ? item.size / 1024 ** 3
                    : 0.01 | formatNumeric('0,0.00')
                }}</md-table-cell
              >
              <md-table-cell md-label="レコード数" class="record-count">{{
                item.recordCount | formatNumeric('0,0')
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>

        <!-- empty -->
        <div
          class="empty-container"
          v-if="downloadRequests.length == 0 && loaded"
        >
          <md-empty-state
            md-icon="directions_run"
            md-label="さっそく作成しましょう！"
            md-description="まだデータが作成されていません。"
          >
            <md-button @click="newRequest" class="md-primary md-raised"
              >データを作成する</md-button
            >
          </md-empty-state>
        </div>

        <!-- ステータス -->
        <div class="status-container" v-if="summary">
          <md-card class="md-elevation-4">
            <md-card-header class="md-title" :class="statusTitleClass">
              <div>
                {{ this.selected.description }}
              </div>
            </md-card-header>
            <md-card-content>
              <request-filter-summary icon="search" title="タイプ">{{
                this.summary.type
              }}</request-filter-summary>
              <request-filter-summary icon="table" title="出力項目">{{
                this.summary.outputColumns
              }}</request-filter-summary>
              <request-filter-summary icon="calendar" title="期間">{{
                this.summary.term
              }}</request-filter-summary>
              <request-filter-summary icon="item" title="商品分類">{{
                this.summary.item
              }}</request-filter-summary>
              <request-filter-summary icon="store" title="店舗">{{
                this.summary.store
              }}</request-filter-summary>
              <request-filter-summary icon="customers" title="顧客指定">{{
                this.summary.customer
              }}</request-filter-summary>
              <md-card-actions md-alignment="left">
                <md-button
                  class="md-raised md-primary"
                  @click="download"
                  :disabled="!canDownload"
                  >ダウンロード</md-button
                >
                <md-button class="md-raised md-primary" @click="recycle"
                  >条件を再利用</md-button
                >
                <md-card-content v-if="this.summary.password">
                  パスワード
                  <div
                    class="password"
                    @click="clipboard"
                    gl-tooltip="クリックしてコピー"
                    gl-tooltip-direction="right"
                  >
                    {{ this.summary.password }}
                  </div>
                </md-card-content>
              </md-card-actions>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </md-content>
  </mouse-layout>
</template>

<script>
import RequestFilterSummary from '@/components/RequestFilterSummary.vue'
import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog.vue'
import { filter } from 'rxjs/operators'
import MouseLayout from '@/components/layout/MouseLayout'
import basic from '@/queryfilter/basic'
import term from '@/queryfilter/term'
import item from '@/queryfilter/item'
import store from '@/queryfilter/store'
import customer from '@/queryfilter/customer'

export default {
  components: {
    RequestFilterSummary,
    MouseLayout,
  },
  data() {
    return {
      downloadRequests: [],
      selected: undefined,
      summary: undefined,
      loaded: false,
      loading: false,
      canDownload: false,
    }
  },
  computed: {
    statusTitleClass() {
      if (this.summary) {
        return this.summary.status.toLowerCase()
      }
      return undefined
    },
  },
  methods: {
    // 一覧選択
    async onSelect(selected) {
      if (selected) {
        this.selected = selected
        this.canDownload =
          selected.status === 'Completed' && 0 < selected.recordCount
        const queryFilter = JSON.parse(selected.queryFilter)
        const baseOutputColumns = this.$store.state.queryMetadata.outputColumns
        this.summary = {
          status: selected.status,
          password: selected.password,
          type: queryFilter.type === 'idpos' ? 'ID-POS' : 'POS',
          outputColumns: basic.summaryTextForOutputColumns(
            baseOutputColumns,
            queryFilter,
          ),
          term: term.summaryText(queryFilter.term),
          item: item.summaryText(queryFilter.item),
          store: store.summaryText(queryFilter.store),
          customer: customer.summaryText(queryFilter.customer),
        }
      } else {
        this.selected = undefined
        this.canDownload = false
        this.summary = undefined
      }
    },
    clipboard() {
      navigator.clipboard.writeText(this.summary.password)
    },
    // データを作成
    newRequest() {
      this.$router.push({ name: 'query-mouse' })
    },
    // ダウンロード
    async download() {
      const url = await this.$repositories
        .get('downloadRequest')
        .getDownloadUrl(this.selected.requestId)

      if (url) {
        window.open(url)
      } else {
        throw new Error('ファイルが存在しない', this.selected.requestId)
      }
    },
    // 再作成
    async recycle() {
      const requestId = this.selected.requestId
      this.$router.push({ name: 'query-mouse', params: { requestId } })
    },
    // 削除
    async deleteRequest() {
      const description = this.selected.description
      const requestId = this.selected.requestId

      this.$dialog
        .open(ConfirmationDialog, {
          message: `「${description}」を削除します。`,
          buttonTextOk: '削除する',
        })
        .pipe(filter(response => response))
        .subscribe(async () => {
          await this.$repositories.get('downloadRequest').delete(requestId)
          this.reload()
        })
    },
    // 更新
    async reload() {
      this.loading = true
      this.downloadRequests = await this.$repositories
        .get('downloadRequest')
        .get()

      this.selected = undefined
      this.summary = undefined
      this.loaded = true
      this.loading = false
    },
  },
  async mounted() {
    this.reload()
  },
}
</script>

<style scoped lang="scss">
$completed: #00c752;
$working: #616161;
$noresult: #ffab00;
$error: #da4336;

.container {
  width: 100%;
}
.status-icon {
  cursor: pointer;
}
.password {
  cursor: pointer;
  text-decoration: underline;
}
.status-container {
  margin-top: var(--spacing-large);
  margin-left: var(--spacing-medium);
  margin-right: var(--spacing-small);
}
.md-title {
  color: var(--text-color-accent);
  &.completed {
    background-color: $completed;
  }
  &.working {
    background-color: $working;
  }
  &.error {
    background-color: $error;
  }
  &.noresult {
    background-color: $noresult;
  }
}

.operation-container {
  margin-left: var(--spacing-medium);
  display: flex;
  width: calc(100% - 20px);
}
.table-container {
  .table {
    margin-left: var(--spacing-medium);
    width: calc(100% - 20px);
    height: 240px;
    max-height: 300px;
  }
}
.status-icon {
  .completed {
    color: $completed;
  }
  .error {
    color: $error;
  }
  .noresult {
    color: $noresult;
  }
}
.md-table-row {
  .status {
    text-align: center;
    width: 30px;
  }
  .requested-at {
    width: 200px;
  }
  .size {
    width: 200px;
    max-width: 100px;
    text-align: right;
  }
  .record-count {
    width: 200px;
    max-width: 100px;
    text-align: right;
  }
}
</style>
